import axios from 'axios'
import { baseUrl } from './base'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    baseURL: baseUrl.urlOnline,
    timeout: 20000
})
service.interceptors.request.use(function (config) {
    return config
}, function (error) {
    return Promise.reject(error)
})
service.interceptors.response.use(function (response) {
    return Promise.resolve(response)
}, function (error) {
    return Promise.reject(error)
})
export default service